var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00031 0.116211C2.68611 0.116211 3.25568e-08 2.80232 3.25568e-08 6.1159C-8.20546e-05 6.90389 0.155065 7.68419 0.456579 8.41222C0.758094 9.14024 1.20007 9.80175 1.75727 10.3589C2.31446 10.9161 2.97597 11.3581 3.70399 11.6596C4.43202 11.9611 5.21232 12.1163 6.00031 12.1162C9.31327 12.1162 12 9.4301 12 6.1159C12 2.80232 9.31327 0.116211 6.00031 0.116211ZM6.56028 2.28235C7.14525 2.28235 7.31712 2.62171 7.31712 3.00981C7.31712 3.49416 6.92964 3.94226 6.2678 3.94226C5.71408 3.94226 5.45034 3.66415 5.46659 3.20355C5.46659 2.81545 5.79095 2.28235 6.56028 2.28235ZM5.06161 9.70946C4.66163 9.70946 4.36977 9.46635 4.64913 8.40078L5.10723 6.51025C5.1866 6.20777 5.19973 6.08653 5.10723 6.08653C4.98787 6.08653 4.46852 6.29526 4.16228 6.5015L3.96292 6.17465C4.93474 5.36281 6.05218 4.88659 6.53028 4.88659C6.93026 4.88659 6.99651 5.35906 6.79715 6.08653L6.27217 8.07392C6.17905 8.42515 6.21905 8.5464 6.31217 8.5464C6.43216 8.5464 6.82464 8.4014 7.21087 8.09705L7.43711 8.40078C6.49154 9.34573 5.46097 9.70946 5.06161 9.70946Z",
    fill: "#090909",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.4b8d91bd64e7380d166361833f5d553e.svg";
export { ForwardRef as ReactComponent };